// extracted by mini-css-extract-plugin
export default {"packageLabelsList":"dimkt8UR1UxzS3HzFEGQ"};